<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Vehicle Detail</li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Vehicle Detail</h1>
        <hr>

        <!--Insert Components-->
        <div class="row mt-2" v-if="apiReady">
            <div class="col-md-6 col-sm-12" >
                <ObjectDetail :detailObject="detailObject"></ObjectDetail>

                <MapScan :location="location" class="mt-3"></MapScan>
            </div>
            <div class="col-sm-12 col-md-6">
                <TimelineChart :frame_no="frame_no"></TimelineChart>
            </div>
        </div>
    </div>
</template>

<script>
import ObjectDetail from './childComponents/ObjectDetail';
import MapScan from './childComponents/MapScan';
import TimelineChart from './childComponents/charts/TimelineChart';

export default {
    components : {
        ObjectDetail,
        MapScan,
        TimelineChart
    },
    mounted(){
        this.getData();
    },
    data(){
        return {    
            detailObject : null,
            location : null,
            apiReady : false,
            frame_no : this.$route.params.frame_no
        }
    },
    methods : {
        getData(){
            let url = '/api/vehicle/detail/' + this.$route.params.frame_no;

            this.$http.get(url)
            .then((resp)=>{
                         
                var data = resp.data.data;

                this.detailObject = data.detailData;
                this.location = data.location;
                this.apiReady = true;
            })
            .catch((err)=>{
                console.log(err);
                
            })
        }
    }
}
</script>